import React from 'react';
import { Formik, Form, Field } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as dataSeed from '../shared/DataSeed';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, ModalHeader
} from 'reactstrap';
import { bankBRIValidationActions } from '../store/BriValidation.Reducer';

class BankValidationBRI extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            message: 'Gagal Validasi',
            norek: localStorage.getItem('norek') || '',
            noHandphone: localStorage.getItem('noHandphone') || '',
            kepemilikanAsset: localStorage.getItem('kepemilikanAsset') || '1',
            agreementBO: false,
            agreementCheck: false,
            validationCode: '',
            isLoading: false,
            openOTPDialog: false,
            OTPInput: '',
            nama: '',
            fotoSpecimen: '',
            pilihBank: localStorage.getItem('pilihBank'),
            imageHash: '',
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleValidateClick = this.handleValidateClick.bind(this);
        this.validateNumber = this.validateNumber.bind(this);
        this.reloadCaptcha = this.reloadCaptcha.bind(this);
        this.handleValidateOTP = this.handleValidateOTP.bind(this);
    }

    validateNumber(evt, setFieldValue, values) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }


        if (evt.target.name === 'MobilePhoneBank') {
            //console.log('mobileephonebank...');
            setFieldValue('MobilePhone', evt.target.value);
            setFieldValue('MobilePhoneConfirmation', evt.target.value);
            //setFieldValue('Address1', 'dsfsdfsdfds');
            //console.log(evt.target.value);
        }
        setFieldValue(evt.target.name, evt.target.value);
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
        if (name === 'norek') {
            this.props.setNorek(event.target.value);
        }
        if (name == 'noHandphone') {
            this.setState({ noHandphone: value });
        }

        if (name === 'agreement') {
            this.setState({ agreementCheck: event.target.checked });
        }

        if (name === 'agreementBO') {
            this.setState({ agreementBO: true })
        }

        if (name === 'OTPInput') {
            this.setState({ OTPInput: value });
        }

        localStorage.setItem(name, value);
        //setFieldValue(event.target.name, event.target.value);
    }

    async handleValidateClick(values) {

        if (this.state.agreementBO
            && this.state.agreementCheck
            && this.state.kepemilikanAsset.length > 0) {
            if (this.state.kepemilikanAsset === "2") {
                alert('Untuk pembukaan rekening yang mempresentasikan pihak lain silakan hubungi customer service kami di nomor 021-83788900 untuk panduan pembukaan account secara offline');
            } else {
                await this.props.requestBankValidation(values.BankAccountNumber2, values.BankAccountHolderName2, values.MobilePhoneBank, values.BankCode2, this.state.validationCode);
                this.setState({ imageHash: Date.now(), validationCode: '' });
                if (this.props.bcaValidation.error) {
                    this.setState({ error: true });
                }
                if (this.props.bcaValidation.entity.responseCode == "00") {
                    localStorage.setItem('BankValidationCode', this.props.bcaValidation.entity.RefNo);
                    this.setState({ openOTPDialog: true });
                } else {
                    alert("Proses verifikasi rekening BRI gagal. (" + this.props.bcaValidation.entity.responseDescription + ")");
                }
            }
        } else {
            alert('Mohon isi data dengan lengkap');
        }
    }

    async handleValidateOTP(values, setFieldTouched, setFieldValue) {
        const url = `api/bri/OTPVerification?kodeOTP=` + values.OTPInput;

        const token = localStorage.getItem('verificationToken');        

        if (!token) {
            alert('Session registrasi expired');
            window.location = '';
        }

        const response = await fetch(url, {
            method: "GET",
            contentType: false,
            processData: false,
            headers:
                new Headers({
                    'Authorization': `Bearer ${token}`,
                }),
        });
        //.then((response) => {
        //    return response.json();
        //})
        //.then((data) => {
        //    if (data.responseCode == "00") {
        //        localStorage.setItem("registrationID", data.registrationID);
        //        setFieldValue("RegistrationID", data.registrationID);

        //        await this.props.saveTmpData(values, -2);

        //        this.props.nowVerifikasiDataPribadi(values, setFieldTouched);
        //    } else if (data.responseCode == "02") {
        //        alert(data.message);
        //        window.location.reload();
        //    } else {
        //        alert(data.message);
        //    }
        //});

        const data = await response.json();
        switch (data.responseCode) {
            case '00':
                setFieldValue("RegistrationID", data.registrationID);
                const updatedValues = {
                    ...values,
                    RegistrationID: data.registrationID
                };
                await this.props.saveTmpData(updatedValues, -2);
                this.props.nowVerifikasiDataPribadi(values, setFieldTouched);
                break;
        }

    }

    onChangeSelection(e) {
        this.setState({ kepemilikanAsset: e.target.value });
    };

    reloadCaptcha = () => {
        this.setState(({ imageHash: Date.now() }));
    };

    render() {
        // const { success, message } = this.state;


        const imageValidation = "/api/register/image-validation";
        const { bcaValidation, values, setFieldValue, setFieldTouched } = this.props;

        let daftarButton, msgAlert, verifikasiButton;

        if (bcaValidation.entity.ResponseCode === "00") {

            daftarButton = <Button type="button" color="primary" onClick={this.props.nowVerifikasiDataPribadi} className="btn-block">Lanjutkan</Button>;

            // this.setState({validated: 'true'});
        } else {
            daftarButton = null;
        }

        if (bcaValidation.entity.ResponseCode === "00") {
            msgAlert = <Alert color="success">Data bank telah berhasil diverfikasi, silakan klik tombol 'Lanjutkan'.</Alert>
            verifikasiButton = null;
        } else if (bcaValidation.entity.ResponseCode === "01") {
            msgAlert = <Alert color="danger">{bcaValidation.entity.Message}</Alert>;
            verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
        } else if (bcaValidation.entity.ResponseCode === "02") {
            msgAlert = <Alert color="danger">{bcaValidation.entity.Message}</Alert>;
        } else if (bcaValidation.entity.ResponseCode === "03") {
            alert(bcaValidation.entity.Message);
            window.location.reload();
        } else {
            msgAlert = null;
            verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
        }

        return (
            <React.Fragment>
                <Modal isOpen={bcaValidation.isLoading}>
                    <ModalBody className="text-center">
                        <Spinner color="success" /><br />Loading..
                    </ModalBody>
                </Modal>


                {this.state.error ?
                    <Modal isOpen={bcaValidation.error}>
                        <ModalHeader size={"sm"}>{bcaValidation.entity.title}</ModalHeader>
                        <ModalBody className="text-center">
                            <ul>
                                {Object.keys(bcaValidation.entity.errors).map(function (key) {
                                    return <li className={"text-danger"}>{bcaValidation.entity.errors[key][0]}</li>
                                }, this)
                                }
                            </ul>
                        </ModalBody>
                        <ModalFooter>
                            <Button size={"sm"} color="primary" onClick={() => this.setState({ error: false })}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    : null}


                <Modal isOpen={this.state.openOTPDialog}>
                    <ModalHeader size={"sm"}>Verifikasi OTP BRI</ModalHeader>
                    <ModalBody className="text-center">
                        <Row>
                            <Col md="12"><FormGroup>
                                <Label for="OTPInput">Masukan OTP - {bcaValidation.entity.otp}</Label>
                                <Input tag={Field} type="tel" name="OTPInput" id="OTPInput" />
                            </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button size={"sm"} color="primary" onClick={(e) => this.handleValidateOTP(values, setFieldTouched, setFieldValue)}>Verifikasi</Button>
                        <Button size={"sm"} color="secondary" onClick={(e) => this.setState({ openOTPDialog: false })}>Close</Button>
                    </ModalFooter>
                </Modal>

                <Fade in={true}>
                    {/*<Formik >*/}
                    {/*    <Form autoComplete="off">*/}
                    <UncontrolledAlert color="warning">Sebelum melanjutkan mohon mempersiapkan dokumen pendukung KTP.</UncontrolledAlert>
                    <p className="text-danger"><b>Sebaiknya menggunakan browser Chrome / Firefox / Safari</b>
                        <br />Pastikan Rekening BRI Anda sudah terdaftar pada aplikasi BRImo dan gunakan nomor handphone yang terdaftar pada aplikasi BRImo</p>
                    <p>Panduan Pembukaan Rekening online <a href="https://yb.co.id/howtoregist" target="__blank">Klik disini</a></p>
                    {msgAlert}

                    <FormGroup tag="fieldset">
                        <legend>Verifikasi Data Rekening {this.state.pilihBank}</legend>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Nomor Rekening <span className="text-danger">*</span></Label>
                                    <Input tag={Field} onChange={(e) => this.validateNumber(e, setFieldValue, values)} type="tel" name="BankAccountNumber2" maxLength="20" bsSize="sm" min="1" max="100000000000" />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Nomor Handphone<span className="text-danger">*</span></Label>
                                    <Input tag={Field} type="tel" name="MobilePhoneBank" maxLength="20" onChange={(e) => this.validateNumber(e, setFieldValue, values)} max="100000000000" minLength="15" bsSize="sm"

                                        onKeyDown={(e) => {
                                            if (e.key === '+') {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Kepemilikan Asset<span className="text-danger">*</span></Label>
                                    {bcaValidation.entity.ResponseCode === "00" ?
                                        <Input type="text" disabled value="Diri Sendiri" bsSize="sm"
                                        />
                                        : <Input type={"select"}
                                            className="form-control-sm"
                                            onChange={(e) => this.onChangeSelection(e)}                                                >
                                            <option value="" >-- Pilih --</option>
                                            <option selected="selected" value={"1"}>Diri Sendiri</option>
                                            <option value={"2"}>Merepresentasikan Pihak Lain</option>
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                            {/*<Col md="4">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>Nama Pemegang Rekening<span className="text-danger">*</span></Label>*/}
                            {/*        <Input type="text" name="nama" value={this.state.nama} onChange={this.handleChange} maxLength="11" bsSize="sm" min="1" />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                        </Row>
                        <Row>


                        </Row>
                        {/*<Row>*/}
                        {/*    <Col md="2" sm="5" xs="12">*/}
                        {/*        <FormGroup>*/}
                        {/*            <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />*/}
                        {/*            <img src={imageValidation + '?' + this.state.imageHash} alt="" />*/}
                        {/*            <Button onClick={() => this.reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>*/}
                        {/*            <Input type="text" name="validationCode" value={this.state.validationCode} onChange={this.handleChange} required="required" maxLength="4" bsSize="sm" />*/}
                        {/*        </FormGroup>*/}
                        {/*    </Col>*/}
                        {/*    <Col md="5">*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                        <Row>
                            <Col md="12">
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="agreement" onChange={this.handleChange} />
                                        Saya Dengan ini memberikan persetujuan kepada PT Yakin Bertumbuh Sekuritas untuk meminta konfirmasi atas data rekening saya tersebut diatas kepada PT Bank Rakyat Indonesia
                                        <span className="text-danger">*</span>
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md="12">
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="agreementBO" onChange={this.handleChange} />
                                        Saya Dengan ini Menyatakan bahwa saya bertindak atas diri sendiri dan bukan untuk kepentingan orang lain (beneficiary owner)
                                        <span className="text-danger"> *</span>
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="3" xs="12" sm="12">
                                {verifikasiButton}{daftarButton}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                Estimasi pembuatan akun 2 x 24 Jam Kerja*<br />
                                Syarat dan Ketentuan Berlaku*
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <br />
                            </Col>
                        </Row>
                    </FormGroup>
                    {/*    </Form>*/}
                    {/*</Formik>*/}
                </Fade>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestBankValidation: bankBRIValidationActions.requestBankValidation
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BankValidationBRI);



// WEBPACK FOOTER //
// ./src/components/BankValidationBRI.js